import { render, staticRenderFns } from "./teachingPointList.vue?vue&type=template&id=d99ff140&scoped=true&"
import script from "./teachingPointList.vue?vue&type=script&lang=js&"
export * from "./teachingPointList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99ff140",
  null
  
)

export default component.exports